import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import { getDirectMAWBData, getFFAirExportDirectShipmentList } from '../../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';
import { convertYYYY_MM_DDtoDD_MMM_YYYYformat } from '../../../../../HelperFunctions';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import OverlayLoader from '../../../../../Common/Loaders/OverlayLoader';
import Tabbings from '../Tabs/Tabbings';
import AEDirectMAWBDownloadOptionsModal from './AEDirectMAWBDownloadOptionsModal';


const ListFFAirExpDirectMAWB = ({ accessedModules, accessedPermission, title, console_manifest_url, console_master_url, console_house_url, direct_master_url, job_order_url, tab_imp_exp, tab_air_sea }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;


    //download modal
    const [mawb_id, setMawb_id] = useState(0);
    const [mawb_number, setMawb_number] = useState("");
    const [showDownload, setShowDownload] = useState(false);

    const handleShowDownload = (id, mawb_number) => {
        if (!id) {
            toast.error("MAWB ID not found.");
            return;
        }
        setMawb_id(id);
        setMawb_number(mawb_number);
        setShowDownload(true);
        dispatch(getDirectMAWBData(token, user_id,id))
    };

    const handleCloseDownload = () => setShowDownload(false);

    //pagination 
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFAirExportDirectShipmentList(token, user_id, queryParams.get("page") ?? 1));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);

    const {
        loadingFFAirExpDirectShipmentList,
        FFAirExpDirectShipmentList,
        FFAirExpDirectShipmentListError,
        FFAirExpDirectShipmentListCurrentPage,
        FFAirExpDirectShipmentListTotalPage,
        FFAirExpDirectShipmentListTotalData,


        loadingDirectMAWBData,
        DirectMAWBData,
        DirectMAWBDataError
    } = useSelector(state => state?.FFAirExpReducer);

    useEffect(() => {
        if (loadingFFAirExpDirectShipmentList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingFFAirExpDirectShipmentList]);

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);

    const downloadMAWB = (id, mawb_number) => {
        if (!id) { toast.error("HAWB not found"); return; }
        // console.log("hi hello")
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/direct-shipment/mawb/download?id=${id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `FF_AE_DIRECT_MAWB${mawb_number}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }


    useEffect(() => {
        if (FFAirExpDirectShipmentList) {
            let arr = [];
            FFAirExpDirectShipmentList.map((val, index) => {
                let obj = {
                    sno: index + 1,
                    mawb_number: val.mawb_number,
                    job_order_number: val.ff_job_order ? val.ff_job_order.job_order_unique_no : "-",
                    // shipper: val.shipper_id,
                    shipper: val.ff_direct_shipment_customer ? val.ff_direct_shipment_customer?.name : "-",
                    // shipper_branch: val.shipper_branch_id,
                    shipper_branch: val.ff_direct_shipment_customer_branch ? val.ff_direct_shipment_customer_branch?.branch_name : "-",
                    // shipper_bank: val.shipper_branch_bank_account_id,
                    shipper_bank: val.ff_direct_shipment_customer_branch_bank ? val.ff_direct_shipment_customer_branch_bank?.entity_name : "-",
                    consignee: val.ff_direct_consignee_customer ? val.ff_direct_consignee_customer?.name : "-",
                    consignee_branch: val.ff_direct_consignee_customer_branch ? val.ff_direct_consignee_customer_branch?.branch_name : "-",
                    consignee_bank: val.ff_direct_consignee_customer_branch_bank ? val.ff_direct_consignee_customer_branch_bank?.entity_name : "-",
                    agent_name: val.issuing_carrier_agent_name,
                    agent_address: val.issuing_carrier_agent_address,
                    agent_iata: val.agent_iata_code,
                    agent_account: val.agent_account_number,
                    airway_bill_date: val.airwaybill_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.airwaybill_date) : "",
                    clearance_exec_date: val.clearance_Exec_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.clearance_Exec_date) : "",
                    csr_date: val.CSR_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.CSR_date) : "",
                    executed_at: val.executed_at ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.executed_at) : "",
                    sli_received: val.is_sli_recived,
                    current_status: val.current_status,
                    action: (
                        <div className="dropdown table-action">
                            <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                                <i className="fa fa-ellipsis-v"></i>
                            </Link>
                            <div className="dropdown-menu dropdown-menu-right">
                                {accessedPermission.includes("ff_ae_direct_shipment_edit") && <div className="dropdown-item" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/direct/mawb/edit/${btoa(val.id)}`) }} >
                                    <i className="fa-solid fa-edit text-blue-light me-1"></i> Edit
                                </div>}
                                {accessedPermission.includes("ff_ae_direct_shipment_download") && <button className="dropdown-item" onClick={() => { handleShowDownload(val.id, val.mawb_number) }} disabled={disableDownloadPDF} >
                                    {disableDownloadPDF ? <><i className="fas fa-spinner fa-spin me-1"></i> Downloading...</> : <><i className="fa-solid fa-download text-blue-light me-1"></i> Download MAWB</>}
                                </button>}
                            </div>
                        </div>
                    ),
                };
                arr.push(obj);
            });
            setDataSource(arr);
        }
    }, [FFAirExpDirectShipmentList]);

    useEffect(() => {
        if (FFAirExpDirectShipmentListCurrentPage) {
            setCurrentPage(FFAirExpDirectShipmentListCurrentPage);
        }

        if (FFAirExpDirectShipmentListTotalPage) {
            setTotalPages(FFAirExpDirectShipmentListTotalPage)
        }
    }, [
        FFAirExpDirectShipmentListCurrentPage,
        FFAirExpDirectShipmentListTotalPage,
        FFAirExpDirectShipmentListTotalData
    ]);

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };


    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "MAWB No.", dataIndex: "mawb_number", key: "mawb_number" },
        { title: "Job Order No.", dataIndex: "job_order_number", key: "job_order_number" },
        { title: "Shipper", dataIndex: "shipper", key: "shipper" },
        { title: "Shipper Branch", dataIndex: "shipper_branch", key: "shipper_branch" },
        { title: "Shipper Bank", dataIndex: "shipper_bank", key: "shipper_bank" },
        { title: "Consignee", dataIndex: "consignee", key: "consignee" },
        { title: "Consignee Branch", dataIndex: "consignee_branch", key: "consignee_branch" },
        { title: "Consignee Bank", dataIndex: "consignee_bank", key: "consignee_bank" },
        { title: "Agent Name", dataIndex: "agent_name", key: "agent_name" },
        { title: "Agent Address", dataIndex: "agent_address", key: "agent_address" },
        { title: "Agent IATA", dataIndex: "agent_iata", key: "agent_iata" },
        { title: "Agent Account No", dataIndex: "agent_account", key: "agent_account" },
        { title: "Airway Bill Date", dataIndex: "airway_bill_date", key: "airway_bill_date" },
        { title: "Clearance Exec Date", dataIndex: "clearance_exec_date", key: "clearance_exec_date" },
        { title: "CSR Date", dataIndex: "csr_date", key: "csr_date" },
        { title: "Executed At", dataIndex: "executed_at", key: "executed_at" },
        { title: "SLI Received", dataIndex: "sli_received", key: "sli_received" },
        { title: "Current Status", dataIndex: "current_status", key: "current_status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];




    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    {title} <span className="count-title">{FFAirExpDirectShipmentListTotalData ? FFAirExpDirectShipmentListTotalData : "0"}</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>
                            <Tabbings
                                console_manifest_url={console_manifest_url}
                                console_master_url={console_master_url}
                                console_house_url={console_house_url}
                                direct_master_url={direct_master_url}
                                job_order_url={job_order_url}
                                accessedPermission={accessedPermission}
                                tab_imp_exp={tab_imp_exp}
                                tab_air_sea={tab_air_sea}
                            />
                            <div className="card">
                                <div className="card-header">
                                </div>
                                <div className="card-body">
                                    {/* Contact List */}
                                    <div className="table-responsive custom-table">
                                        <Table className="table datanew dataTable no-footer"
                                            // rowSelection={rowSelection} 
                                            dataSource={dataSource}
                                            columns={columns}
                                            pagination={false} />
                                    </div>

                                    <div className="row align-items-center">
                                        {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                            <ReactPaginate
                                                previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                nextLabel={<img src="/img/left.png" alt="Next" />}
                                                breakLabel="..."
                                                breakClassName="break-me"
                                                pageCount={totalPages}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageClick}
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                forcePage={currentPage - 1}
                                            />
                                        </div> :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            {
                disableDownloadPDF && <OverlayLoader />
            }
            <AEDirectMAWBDownloadOptionsModal
                show={showDownload}
                handleClose={handleCloseDownload}
                token={token}
                user_id={user_id}
                id={mawb_id}
                mawb_number={mawb_number}
                loadingDirectMAWBData={loadingDirectMAWBData}
                DirectMAWBData={DirectMAWBData}
            />
        </>

    )
}

export default ListFFAirExpDirectMAWB